const items = [
  "Automated categorization",
  "Reports & statistics",
  "Desktop & mobile sync",
  "Optional AI insights",
  "Privacy first",
  "Calmer money habits",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif-display whitespace-nowrap px-8 text-2xl italic text-slate-500 transition-colors sm:text-3xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-sky-400/50" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-sky-400/10 bg-[#0F1C36]/40 py-7"
    data-testid="marquee"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0A1224] to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0A1224] to-transparent" />
  </div>
);
